var render = function render(){var _vm=this,_c=_vm._self._c;return _c('searches-groups-list-page',{attrs:{"resource-name":"searches","is-initiated":_vm.searchesAreInitiated,"data":_vm.searchesData,"no-data":_vm.searchesNoData,"all-loaded":_vm.searchesAllLoaded,"can-load-more-string":"searchesCanLoadMore","is-busy":_vm.searchesAreBusy}})
}
var staticRenderFns = []

export { render, staticRenderFns }